import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FormControl,
  FormHelperText,
  Checkbox,
  FormControlLabel,
  makeStyles,
} from '@material-ui/core';

import './style.scss';

const useStyles = makeStyles((theme) => ({
  checkboxHelperText: {
    fontSize: '14px',
    fontStyle: 'italic',
    color: '#323232',
  },
  checkboxFormControl: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}));

const buildRequirements = (insuranceProductId) => [
  {
    id: 1,
    img: require('../../img/icon_cerradura.svg'),
    description:
      'Cerraduras doble paleta o bidimensionales en puertas de acceso.',
  },
  {
    id: 2,
    img: require('../../img/icon_reja.svg'),
    description:
      'Rejas de protección de hierro en ventanas y puertas (solo en PB y 1 er Piso).',
  },
  {
    id: 3,
    img: require('../../img/icon_fire.svg'),
    description:
      insuranceProductId === '3322'
        ? 'Vivienda localizada en área urbana con cobertura de departamento de bomberos, con construcción en madera igual o inferior al 60% del total.'
        : 'Construída íntegramente de material incombustible, con techos sólidos y paredes externas de material.',
  },
  {
    id: 4,
    img: require('../../img/icon_electricidad.svg'),
    description:
      'Cableado eléctrico embutido y conexiones eléctricas en buen estado.',
  },
  {
    id: 5,
    img: require('../../img/icon_cam.svg'),
    description:
      'Medianeras o perímetro cerrado con vigilancia privada permanente.',
  },
];

const buildRequirementsIC = (insuranceProductId) => [
  {
    id: 1,
    img: require('../../img/icon_construccion.svg'),
    description:
      'Construcción de hormigón armado y/o mampostería de ladrillos.',
  },
  {
    id: 2,
    img: require('../../img/icon_techo.svg'),
    description:
      'Techos sólidos e incombustibles de hormigón armado y/o mampostería de ladrillos.',
  },
  {
    id: 3,
    img: require('../../img/icon_electricidad.svg'),
    description: 'Instalaciones eléctricas en buenas condiciones.',
  },
  {
    id: 4,
    img: require('../../img/icon_extintor.svg'),
    description:
      'Extintores reglamentarios operables con sus cargas actualizadas.',
  },
  {
    id: 5,
    img: require('../../img/icon_baldio.svg'),
    description:
      'No lindero a terrenos baldíos, obras en construcción, y/o edificios abandonados.',
  },
  {
    id: 6,
    img: require('../../img/icon_cerradura.svg'),
    description: 'Cerradura doble paleta en todas las puertas de acceso.',
  },
  {
    id: 7,
    img: require('../../img/icon_reja.svg'),
    description:
      'Aberturas vidriadas protegidas con rejas, cortinas, postigos o cristales de seguridad.',
  },
  {
    id: 8,
    img: require('../../img/icon_salida_emergencia.svg'),
    description:
      'Salidas de emergencia libres de obstáculos y en perfectas condiciones de operabilidad.',
  },
  {
    id: 9,
    img: require('../../img/icon_candado.svg'),
    description:
      'Portones y otras puertas de escape con cerraduras de seguridad o candados de inviolables.',
  },
];

const Requirement = ({ id, img, description }) => {
  return (
    <div className='Requeriments-MinimumRequirementsHome'>
      <div className='Icon-MinimumRequirementsHome'>{id}</div>
      <div className='SVG-Icon-MinimumRequirementsHome'>
        <img src={img} alt='' />
      </div>
      <div className='Line-MinimumRequirementsHome'></div>
      <div className='Text-MinimumRequirementsHome'>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default function MinimumRequirements({
  acceptTerms,
  setAcceptTerms,
  insuranceProductId,
}) {
  const classes = useStyles();

  const requirements = buildRequirements(insuranceProductId);
  const requirementsIC = buildRequirementsIC(insuranceProductId);

  const { insuranceName } = useSelector(({ insurances }) => ({
    insuranceName: insurances.selected && insurances.selected.insuranceName,
  }));

  const [messageReq] = useState(
    insuranceName === 'INTEGRAL DE COMERCIO' ? (
      <span>
        <b>REQUISITOS Y MEDIDAS MINIMAS DE SEGURIDAD</b> EXIGIDAS PARA UN SEGURO
        DE INTEGRAL DE COMERCIO
      </span>
    ) : (
      <span>
        <b>REQUISITOS Y MEDIDAS MINIMAS DE SEGURIDAD</b> EXIGIDAS PARA UN SEGURO
        DE HOGAR
      </span>
    )
  );

  const [helperText] = useState(
    insuranceName === 'INTEGRAL DE COMERCIO' ? (
      <span>
        En caso de no cumplirse una o más de las condiciones antes mencionadas y
        de producirse un siniestro cuya ocurrencia o magnitud haya sido
        facilitado por cualquier de tales circunstancias, la indenmización que
        de otra manera pudiése corresponder, quedará reducida al setenta
        porciento (70%).
      </span>
    ) : (
      <span>
        Declaro conocer y aceptar que no cumpliéndose una o más de las
        condiciones establecidas precedentemente, de producirse un siniestro
        facilitado por cualquiera de tales circunstancias, la compañía abonara
        unicamente el 70% del monto del siniestro o de la suma asegurada, lo que
        resulte menor.
      </span>
    )
  );

  const [reqInsurance] = useState(
    insuranceName === 'INTEGRAL DE COMERCIO' ? requirementsIC : requirements
  );

  return (
    <div className='Main-Container-MinimumRequirementsHome'>
      <div className='Header-MinimumRequirementsHome'>{messageReq}</div>

      <div className='Requeriments-Wrapper-MinimumRequirementsHome'>
        {reqInsurance.map((item) => (
          <Requirement key={item.id} {...item} />
        ))}
      </div>

      <hr />

      <form className='Legal-Container-MinimumRequirementsHome'>
        <FormControl
          fullWidth
          margin='dense'
          classes={{ root: classes.checkboxFormControl }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={acceptTerms}
                onChange={() => setAcceptTerms(!acceptTerms)}
                name='terms'
                color='primary'
              />
            }
            style={{ marginRight: 0, height: '24px' }}
          />
          <FormHelperText classes={{ root: classes.checkboxHelperText }}>
            {helperText}
          </FormHelperText>
        </FormControl>
      </form>
    </div>
  );
}
